module.exports = __webpack_public_path__ + "img/countries-fill.4402b269.svg";